import { render } from "./App.vue?vue&type=template&id=3b1839f9"
const script = {}

import exportComponent from "E:\\七田\\QTEducationSml\\03 开发代码\\SmlSys\\SmlPc\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__